@if (
  ((!endorsementImage) && endorsementLocation?.statusCode !== 'SIGNED') ||
  (isEditing && endorsementLocation?.statusCode === 'SIGNED')) {
  <input data-private #freetextinput
    type="text"
    [(ngModel)]="freeText"
    (focus)="endorsementFocused()"
    (blur)="endorsementBlurred()"
    [disabled]="!this.isEditable"
    class="free-text-endorsement__input"
    [hidden]="!endorsementLocation?.isSignableInCurrentSession"
    [tabindex]="disableFocus ? -1 : 0"
    [attr.data-testid]="'endorsement-textbox-' + this.endorsementLocation?.documentEndorsementLocationId"
    [attr.data-alttestid]="'endorsement-textbox-input-dynamic'" />
} @else {
  @if (endorsementLocation?.statusCode === 'SIGNED') {
    <div class="free-text-endorsement__image-wrapper"
      >
    <img [ngClass]="{
        'free-text-endorsement__image': true,
        'free-text-endorsement__image--hidden': hideIfSigned
      }"
        [src]="'data:image/png;base64,' + endorsementImage?.endorsementImage"
        [attr.data-testid]="'endorsement-textbox-completed-' + this.endorsementLocation?.documentEndorsementLocationId"
        alt="" data-private/>
        @if (isEditable) {
          <span
            class="free-text-endorsement__edit-icon fas fa-edit"
            (click)="editClicked()"
            (keydown.space)="$event.preventDefault(); editClicked()"
          ></span>
        }
      </div>
    }
  }

